import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {ENDPOINT_TYPES_FORMATION} from "../constants/endpoints";

let store = {
  debug: true,
  state: {
    typesFormation: []
  },

  getAll() {
    if (this.state.typesFormation.length === 0) {
      return axios.get(ENDPOINT_TYPES_FORMATION)
          .then(response => {
            this.state.typesFormation = response.data;
            return this.state.typesFormation;
          })
          .catch(error => AlertStore.pushError(error.response.data.message));
    } else {
      return new Promise(resolve => {
        resolve(this.state.typesFormation);
      });
    }
  }
};

export default store;
